import { Component, h, Host, Prop } from '@stencil/core';

/**
 * @slot default - {required}, {multiple}, <me-button variant="ghost">
 * @example
 *   <dropdown-menu-type-1>
 *     <me-button variant="ghost">Help center</me-button>
 *     <me-button variant="ghost">Blog</me-button>
 *     <me-button variant="ghost">FAQ</me-button>
 *   </dropdown-menu-type-1>
 */
@Component({
  tag: 'dropdown-menu-type-1',
  styleUrl: 'index.scss',
  shadow: false,
})
export class DropdownMenuType1 {
  /**
   * Additional class modifiers for styling.
   * @type {string}
   */
  @Prop() modifiers?: string;

  render() {
    return (
      <Host class={`dropdown-menu-type-1 ${this.modifiers || ''}`}>
        <slot></slot>
      </Host>
    );
  }
}
